/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
export { countryCodes } from '../../countries/index.js';
export { State } from 'country-state-city';
import isoCountries from 'i18n-iso-countries';
export { default as isoCountries } from 'i18n-iso-countries';
import enCountries from '../../node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/langs/en.json.js';
import cnCountries from '../../node_modules/.pnpm/i18n-iso-countries@7.14.0/node_modules/i18n-iso-countries/langs/zh.json.js';
import nationalities from 'i18n-nationality';
export { default as nationalities } from 'i18n-nationality';
import enNationalities from '../../node_modules/.pnpm/i18n-nationality@1.4.0/node_modules/i18n-nationality/langs/en.json.js';

isoCountries.registerLocale(enCountries);
isoCountries.registerLocale(cnCountries);
nationalities.registerLocale(enNationalities);

// Language conversion map for supporting different language codes
var languageConversionMap = {
  cn: 'zh'
};

// Map of nationalities that need special handling
var unsupportedNationalities = {
  cn: true
};

export { languageConversionMap, unsupportedNationalities };
//# sourceMappingURL=countries-data-shared.js.map
